/**
 * Shared copy for the in-call "invite by email" row (web + native panels).
 * Both panels mint the same WS grant and render the same delivery outcome,
 * so the wording and the email-shape rule live in exactly one place.
 */
export const INVITE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isInviteEmailCandidate(value) {
    const trimmed = value.trim();
    return trimmed.length <= 254 && INVITE_EMAIL_PATTERN.test(trimmed);
}
const EMAIL_FAILURE_KEYS = {
    EMAIL_NOT_CONFIGURED: 'notConfigured',
    INVALID_GUEST_EMAIL: 'invalid',
    VRI_INVITE_EMAIL_POLICY_DISABLED: 'disabled',
    VRI_INVITE_EMAIL_RATE_LIMITED: 'rateLimited',
    VRI_INVITE_EMAIL_TENANT_DISABLED: 'disabled'
};
/**
 * What the row says after a guest link was emailed (vrs.invite.email.*): sent,
 * or why not in a few words, never the server's sentence.
 */
export function describeInviteEmailOutcome(outcome, t) {
    if (outcome.status === 'sent') {
        return String(outcome.email
            ? t('vrs.invite.email.sent', { email: outcome.email })
            : t('vrs.invite.email.sentGuest'));
    }
    return String(t(`vrs.invite.email.${EMAIL_FAILURE_KEYS[outcome.errorCode || ''] || 'failed'}`));
}
